export default __webpack_public_path__ + "static/media/quickwire.74a06276.png";